import { runtimeConfig } from "@src/runtime-config";
import { sentryCaptureError } from "@utils/sentry-utils";
import { CoreApiClient } from "@stellar/core-api-client";

/** Admin panel identifier to pass to all APIs as header "X-Holobuilder-Component" */
const CLIENT_ID = "adminpanel";

/**
 * New Core API client, used to communicate with Core API backend.
 */
export const faroCoreApiClient = new CoreApiClient({
  baseUrl: runtimeConfig.urls.apiUrl,
  headers: {
    // eslint-disable-next-line @typescript-eslint/naming-convention -- this key is defined by the backend
    "X-Holobuilder-Component": CLIENT_ID,
  },
  // If the return type is different than what we expected, we log an assertion error.
  onLogAssertion: ({ message, error, routeName }) => {
    const title = `CoreApiClient assertion error in route ${routeName}.`;

    // Capture the error with Sentry. The title has the route name making it easy to find.
    // The error shows the message from Zod as it is human readable
    sentryCaptureError({
      title,
      error: message,
      isAssertionError: true,
    });

    // eslint-disable-next-line no-console
    console.error(title, message, error.issues);
  },
});
